import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BANK_SCRAPING_IFRAME_STATUS, BANK_SCRAPING_STATUS } from 'consts/loan/AU';
import { resetBankScrapingResult } from 'actions/proviso';
import { PROVISO_MOCK_URL } from 'consts';
import { trackProvisoStatus } from './trackProvisoStatus';
import { useProvisoUrl } from './useProvisoUrl';
import { useBankScrapingStatusTracking } from './useBankScrapingStatusTracking';
import { useProvisoIframeTracking } from './useProvisoIframeTracking';

export const useBankScrapingAU = () => {
  const dispatch = useDispatch();
  const [retryKey, setRetryKey] = useState(0);
  const loan = useSelector((state) => state.loan);
  const { bankScrapingResult, isProvisoIframeError, provisoUrl } = loan;
  const { status } = bankScrapingResult;

  const isComplete = status === BANK_SCRAPING_STATUS.COMPLETE;
  const isLoginFail = status === BANK_SCRAPING_STATUS.LOGIN_FAIL;
  const isError = isLoginFail || status === BANK_SCRAPING_STATUS.ERROR || isProvisoIframeError;
  const hasIframeUrl = Boolean(provisoUrl) && provisoUrl !== PROVISO_MOCK_URL;
  const shouldGetProvisoUrl = !isComplete && !isLoginFail;

  useProvisoUrl({ dispatch, retryKey, shouldGetProvisoUrl });

  useBankScrapingStatusTracking({
    dispatch, isComplete, isLoginFail, bankScrapingResult,
  });

  const {
    isIframeLoaded, resetIframeLoaded, handleIframeLoad, handleIframeError,
  } = useProvisoIframeTracking({
    dispatch, hasIframeUrl, provisoUrl, retryKey,
  });

  const handleRetry = useCallback(() => {
    dispatch(resetBankScrapingResult());
    resetIframeLoaded();
    setRetryKey((prev) => prev + 1);
    dispatch(trackProvisoStatus(BANK_SCRAPING_IFRAME_STATUS.IFRAME_RELOAD));
  }, [dispatch, resetIframeLoaded]);

  return {
    isError,
    bankScrapingResult,
    iFrameUrl: provisoUrl,
    retryKey,
    isIframeLoaded,
    handleIframeLoad,
    handleIframeError,
    handleRetry,
  };
};
